import(/* webpackMode: "eager", webpackExports: ["Button"] */ "/app/packages/web/node_modules/@base-ui/react/button/Button.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/web/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/app/packages/web/node_modules/next/dist/client/app-dir/link.js");
